import { FC, PropsWithChildren } from "react";
import { useRecoilValue } from "recoil";

import { GoogleApiLoaderContainer } from "@ryde/controls";
import { LANG_DEFAULT } from "@ryde/shared";
import { landingInitDataAtom } from "@ryde/utils-landings";

export const LandingsMapLoader: FC<PropsWithChildren> = ({ children }) => {
  const landingInitData = useRecoilValue(landingInitDataAtom);

  return (
    landingInitData && (
      <>
        <GoogleApiLoaderContainer
          language={landingInitData.language || LANG_DEFAULT}
        />
        {children}
      </>
    )
  );
};
